import { GET_ITEM_LIST } from '../actionConstants';

const onGetItemList = (data) => ({
    type: GET_ITEM_LIST,
    data
});



export { onGetItemList};
